import { render, staticRenderFns } from "./Meta.vue?vue&type=template&id=200b2520&scoped=true"
import script from "./Meta.vue?vue&type=script&lang=js"
export * from "./Meta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b2520",
  null
  
)

export default component.exports